// extracted by mini-css-extract-plugin
module.exports = {"appWrap":"app_appWrap__2v1h6"};